import { RequestType } from './_types';
import { isString, isURL } from './internal/source-checkers';
import { pipe } from './tools/pipe';
import { fields } from './internal/fields';
import { path } from './internal/path';
import { type } from './internal/type';
export const url = (request) => {
    if (!isString(request.source) && !isURL(request.source)) {
        throw new Error('Invalid source, should be url string or instance of URL');
    }
    return pipe(fields({
        url: request.source.toString(),
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
    }), path('/url'), type(RequestType.Url))({
        ...request,
        source: undefined,
    });
};
